import { render, staticRenderFns } from "./FormTambah.vue?vue&type=template&id=5f6c90ea"
import script from "./FormTambah.vue?vue&type=script&lang=js"
export * from "./FormTambah.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports